import React, { Component } from "react";
import NumberFormat from "react-number-format";
import Time from "react-time-format";
import { connect } from "react-redux";
import { change_Lang } from "../../../actions/Helper_action";
import n2wordsEN from "n2words/lib/i18n/AR.mjs";
import "../AllPrint.css";
import { FaMapMarkerAlt, FaPhoneAlt } from "react-icons/fa";
class RentPrintArabic extends Component {
 render() {
  const {
   lang,
   change_Lang,
   rent_invoice_obj,
   index_rentcontrct,
   thirdcolor,
   primary_logo,
   footer_logo,
   user,
   name_arb,
  } = this.props;
  // Kurdish
  let numWords1 =
   rent_invoice_obj.introduction !== undefined &&
   rent_invoice_obj.introduction !== null
    ? n2wordsEN(
       parseFloat(rent_invoice_obj.introduction.toString().replace(/,/g, ""))
      )
    : 0;
  let numWords2 =
   rent_invoice_obj.paymentmonth !== undefined &&
   rent_invoice_obj.paymentmonth !== null
    ? n2wordsEN(
       parseFloat(rent_invoice_obj.paymentmonth.toString().replace(/,/g, ""))
      )
    : 0;
  let numWords3 =
   rent_invoice_obj.feelate !== undefined && rent_invoice_obj.feelate !== null
    ? n2wordsEN(
       parseFloat(rent_invoice_obj.feelate.toString().replace(/,/g, ""))
      )
    : 0;
  let numWords4 =
   rent_invoice_obj.safly !== undefined && rent_invoice_obj.safly !== null
    ? n2wordsEN(parseFloat(rent_invoice_obj.safly.toString().replace(/,/g, "")))
    : 0;
  return (
   <>
    <div className={`container-fluid ${lang !== "en" ? "fk" : "fkp"}`}>
     <div className="conn content-containers" id="tbls">
      <div class="row">
       <div class="col-12  ">
        <img
         src={primary_logo}
         alt="logo"
         className="img-fluid img-responsive"
         style={{
          width: "100%",
         }}
        />
       </div>
      </div>
      <div class="row mt-2">
       <div class="col-4">
        <p
         style={{
          fontSize: "22px",
          color: "#000",
          textAlign: "right",
          fontWeight: "bold",
         }}
         class=" text-uppercase"
        >
         &nbsp;&nbsp;{change_Lang("date")} &nbsp;:&nbsp;
         <Time
          value={rent_invoice_obj.createdAt}
          format="YYYY-MM-DD"
          style={{
           fontSize: "22px",
           color: "#000",
           fontWeight: "bold",
          }}
         />
        </p>
       </div>
       <div class="col-4 d-flex justify-content-center">
        <p
         style={{
          fontSize: "27px",
          color: "#000",
          fontWeight: "bolder",
         }}
         class={`d-flex justify-content-center text-uppercase ${
          lang !== "en" ? "fk" : "fkp"
         } `}
        >
         ({change_Lang("Rental contract")})
        </p>
       </div>
       <div class="col-4 text-right">
        <p
         style={{
          fontSize: "22px",
          color: "#000",
          fontWeight: "bold",
         }}
         class=" text-uppercase"
        >
         {change_Lang("contract number")} #&nbsp;
         {rent_invoice_obj.InvoiceNO}&nbsp;
        </p>
       </div>
      </div>
      <div class="row">
       <div class="col-12">
        <div class="form-group row form-inline">
         <label
          style={{
           fontSize: "26px",
           color: "black",
           fontWeight: "bold",
          }}
          class="col-sm-2 col-form-label"
         >
          {change_Lang("First Side")}:
         </label>
         <div class="col-sm-4">
          <label
           class="d-flex justify-content-start"
           style={{ fontWeight: "bold", fontSize: "22px" }}
          >
           {rent_invoice_obj.firstname}
          </label>
         </div>

         {/* shahed */}
         <label
          style={{
           fontSize: "26px",
           color: "black",
           fontWeight: "bold",
          }}
          class="col-sm-2 col-form-label"
         >
          {/* {change_Lang("Witness")}: */}
          {change_Lang("Second Side")}:
         </label>
         <div class="col-sm-4">
          <label
           class="d-flex justify-content-start"
           style={{ fontWeight: "bold", fontSize: "22px" }}
          >
           {/* {rent_invoice_obj.witness1} */}

           {rent_invoice_obj.tenantId && rent_invoice_obj.tenantId.secondname}
          </label>
         </div>
         {/* phone */}
         {/* <label
                      style={{
                        fontSize: "23px",
                        color: "black",
                        fontWeight: "bold",
                      }}
                      class="col-sm-2 col-form-label fkk"
                    >
                      رقم الهاتف:
                    </label>
                    <div class="col-sm-4">
                      <label
                        class="d-flex justify-content-start"
                        style={{ fontWeight: "bold", fontSize: "18px" }}
                      >
                        {rent_invoice_obj.phone1}
                      </label>
                    </div>
                    <label
                      style={{
                        fontSize: "23px",
                        color: "black",
                        fontWeight: "bold",
                      }}
                      class="col-sm-2 col-form-label fkk"
                    >
                      رقم الهاتف:
                    </label>
                    <div class="col-sm-4">
                      <label
                        class="d-flex justify-content-start"
                        style={{ fontWeight: "bold", fontSize: "18px" }}
                      >
                        {rent_invoice_obj.tenantId &&
                          rent_invoice_obj.tenantId.phone2}
                      </label>
                    </div> */}
         <label
          style={{
           fontSize: "26px",
           color: "black",
           fontWeight: "bold",
          }}
          class="col-sm-2 col-form-label"
         >
          {" "}
          {change_Lang("first_rule_place")}:
         </label>
         <br />
         <div class="col-sm-4">
          <label
           class="d-flex justify-content-start"
           style={{ fontWeight: "bold", fontSize: "22px" }}
          >
           {rent_invoice_obj.available_id &&
            rent_invoice_obj.available_id.Place_ku}
          </label>
         </div>
         {/* shahed 2 */}
         <label
          style={{
           fontSize: "26px",
           color: "black",
           fontWeight: "bold",
          }}
          class="col-sm-2 col-form-label"
         >
          {" "}
          {/* {change_Lang("Witness")}: */}
          {change_Lang("Type of property")}:
         </label>
         <div class="col-sm-4">
          <label
           class="d-flex justify-content-start"
           style={{ fontWeight: "bold", fontSize: "22px" }}
          >
           {/* {rent_invoice_obj.witness2} */}
           {change_Lang(
            rent_invoice_obj.available_id &&
             rent_invoice_obj.available_id.Property
           )}
          </label>
         </div>
         {/* Area */}
         <label
          style={{
           fontSize: "26px",
           color: "black",
           fontWeight: "bold",
          }}
          class="col-sm-2 col-form-label"
         >
          {" "}
          {change_Lang("Number of property")}:
         </label>
         <br />
         <div class="col-sm-4">
          <label
           class="d-flex justify-content-start"
           style={{ fontWeight: "bold", fontSize: "22px" }}
          >
           {rent_invoice_obj.available_id &&
            rent_invoice_obj.available_id.NOoFProperty}
          </label>
         </div>
         {/* shahed 2 */}
         <label
          style={{
           fontSize: "26px",
           color: "black",
           fontWeight: "bold",
          }}
          class="col-sm-2 col-form-label"
         >
          {" "}
          {/* {change_Lang("Witness")}: */}
          {change_Lang("Area")}:
         </label>
         <div class="col-sm-4">
          <label
           class="d-flex justify-content-start"
           style={{ fontWeight: "bold", fontSize: "22px" }}
          >
           {/* {rent_invoice_obj.witness2} */}
           {rent_invoice_obj.available_id && rent_invoice_obj.available_id.Area}
           &nbsp;م<sup>2</sup>
          </label>
         </div>
        </div>
        <p
         style={{
          fontSize: "22px",
          color: "#fff",
          fontWeight: "bold",
          borderRadius: "50px 0px 0px 0px",
         }}
         id="liniar"
         class="my-1 d-flex justify-content-center fk"
        >
         {change_Lang("agreement")}
        </p>
       </div>
      </div>
      <div className="row">
       <div className="col-12">
        <table className="table border-0">
         <tbody>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
           className="border-0"
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{
             color: `${thirdcolor}`,
             borderTop: "none",
            }}
           >
            1-
           </th>
           <td
            style={{
             lineHeight: "1.5",
             wordSpacing: "6px",
             color: "black",
             borderTop: "none",
             fontSize: "23px",
             fontWeight: "bold",
            }}
           >
            وافق الطرف الأول على تأجير هذا العقار المذكور أعلاه إلى الطرف
            الثاني.
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{
             color: `${thirdcolor}`,
             borderTop: "none",
             paddingBottom: "25px",
            }}
           >
            2-
           </th>
           <td
            style={{
             lineHeight: "1.5",
             wordSpacing: "6px",
             color: "black",
             fontSize: "23px",
             borderTop: "none",
             textAlign: "justify",
             fontWeight: "bold",
            }}
           >
            مدة العقد (
            <NumberFormat
             displayType="text"
             thousandSeparator={true}
             value={rent_invoice_obj.rental}
             style={{}}
             className="text-center"
            />
            )شهراً تبدأ من&nbsp;(
            <Time
             value={rent_invoice_obj.startdate}
             format="YYYY-MM-DD"
             style={{
              color: "black",
             }}
            />
            )&nbsp;إلى&nbsp; (
            <Time
             value={rent_invoice_obj.enddate}
             format="YYYY-MM-DD"
             style={{
              color: "black",
             }}
            />
            )&nbsp;وعند انتهاء المدة على الطرف الثاني تخلية العقار دون تبليغ
            مسبق.
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{
             color: `${thirdcolor}`,
             borderTop: "none",
            }}
           >
            3-
           </th>
           <td
            style={{
             lineHeight: "1.5",
             wordSpacing: "6px",
             color: "black",

             fontSize: "23px",
             borderTop: "none",
             textAlign: "justify",
             fontWeight: "bold",
            }}
           >
            وافق كلا الطرفين على أجرة شهرية قدره&nbsp;
            <NumberFormat
             displayType="text"
             thousandSeparator={true}
             value={rent_invoice_obj.paymentmonth}
             style={{}}
             className="text-center"
             prefix={`${rent_invoice_obj.currency === "dolar" ? "$" : "ID"}`}
            />
            &nbsp;
            {numWords2}
            {lang === "en" && rent_invoice_obj.currency === "dolar"
             ? "($)"
             : lang === "krd" && rent_invoice_obj.currency === "dolar"
             ? "(دۆلار)"
             : lang === "arb" && rent_invoice_obj.currency === "dolar"
             ? "(دولار)"
             : lang === "en" && rent_invoice_obj.currency !== "dolar"
             ? "(ID)"
             : lang === "krd" && rent_invoice_obj.currency !== "dolar"
             ? "(دینار)"
             : lang === "arb" && rent_invoice_obj.currency !== "dolar"
             ? "(دینار)"
             : ""}
            .
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{
             color: `${thirdcolor}`,
             borderTop: "none",
            }}
           >
            4-
           </th>
           <td
            style={{
             lineHeight: "1.5",
             wordSpacing: "6px",
             color: "black",

             fontSize: "23px",
             borderTop: "none",
             textAlign: "justify",
             fontWeight: "bold",
            }}
           >
            اني الطرف الثاني ألتزم بتسديد الايجار الشهري مقدماَ كل &nbsp;(
            <NumberFormat
             displayType="text"
             thousandSeparator={true}
             value={rent_invoice_obj.MonthForRent}
             style={{
              fontWeight: `${lang !== "en" ? "bold" : ""}`,
             }}
             className="text-center"
            />
            )&nbsp; أشهر.
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{
             color: `${thirdcolor}`,
             borderTop: "none",
            }}
           >
            5-
           </th>
           <td
            style={{
             lineHeight: "1.5",
             wordSpacing: "6px",
             color: "black",

             fontSize: "23px",
             borderTop: "none",
             textAlign: "justify",
             fontWeight: "bold",
            }}
           >
            يدفع الطرف الثاني مبلغ قدره &nbsp;
            <NumberFormat
             displayType="text"
             thousandSeparator={true}
             value={rent_invoice_obj.introduction}
             style={{}}
             prefix={`${rent_invoice_obj.currency === "dolar" ? "$" : "ID"}`}
             className="text-center"
            />
            &nbsp;
            {numWords1}
            {lang === "en" && rent_invoice_obj.currency === "dolar"
             ? "($)"
             : lang === "krd" && rent_invoice_obj.currency === "dolar"
             ? "(دۆلار)"
             : lang === "arb" && rent_invoice_obj.currency === "dolar"
             ? "(دولار)"
             : lang === "en" && rent_invoice_obj.currency !== "dolar"
             ? "(ID)"
             : lang === "krd" && rent_invoice_obj.currency !== "dolar"
             ? "(دینار)"
             : lang === "arb" && rent_invoice_obj.currency !== "dolar"
             ? "(دینار)"
             : ""}
            &nbsp;كمقدمة (
            <NumberFormat
             displayType="text"
             thousandSeparator={true}
             value={rent_invoice_obj.Monthintroduction}
             className="text-center"
            />
            )&nbsp;شهراً.
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{
             color: `${thirdcolor}`,
             borderTop: "none",
             paddingBottom: "70px",
            }}
           >
            6-
           </th>
           <td
            style={{
             lineHeight: "1.5",
             wordSpacing: "6px",
             color: "black",

             fontSize: "23px",
             borderTop: "none",
             textAlign: "justify",
             fontWeight: "bold",
            }}
           >
            يلتزم الطرف الثاني بدفع مبلغ قدره&nbsp;
            <NumberFormat
             displayType="text"
             thousandSeparator={true}
             style={{}}
             value={rent_invoice_obj.safly}
             className="text-center"
             prefix={`${rent_invoice_obj.currency === "dolar" ? "$" : "ID"}`}
            />
            &nbsp;
            {numWords4}
            {lang === "en" && rent_invoice_obj.currency === "dolar"
             ? "($)"
             : lang === "krd" && rent_invoice_obj.currency === "dolar"
             ? "(دۆلار)"
             : lang === "arb" && rent_invoice_obj.currency === "dolar"
             ? "(دولار)"
             : lang === "en" && rent_invoice_obj.currency !== "dolar"
             ? "(ID)"
             : lang === "krd" && rent_invoice_obj.currency !== "dolar"
             ? "(دینار)"
             : lang === "arb" && rent_invoice_obj.currency !== "dolar"
             ? "(دینار)"
             : ""}
            &nbsp;كتأمينات إلى {name_arb} وفق ورقة الإيصال المرقمة (
            {index_rentcontrct}
            )ويتم تسليم المبلغ بورقة الإيصال نفسها إلى الطرف الثاني بعد انتهاء
            مدة العقد بشرط تسليم العقار دون أي نقص من قبل الطرف الثاني إلى الطرف
            الأول.
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{
             color: `${thirdcolor}`,
             borderTop: "none",
             paddingBottom: "43px",
            }}
           >
            7-
           </th>
           <td
            style={{
             lineHeight: "1.5",
             wordSpacing: "6px",
             color: "black",

             fontSize: "23px",
             borderTop: "none",
             textAlign: "justify",
             fontWeight: "bold",
            }}
           >
            يستخدم الطرف الثاني هذا العقار لغرض ({rent_invoice_obj.perpose}
            )ند استخدامه لأي غرض آخر يجب تبيلغ {name_arb} عن ذلك وبموافقة خطية
            من الطرف الأول. خلافاً لذلك يحق للطرف الأول إبطال العقد دون تبيلغ
            الطرف الثاني.
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{
             color: `${thirdcolor}`,
             borderTop: "none",
             paddingBottom: "35px",
            }}
           >
            8-
           </th>
           <td
            style={{
             lineHeight: "1.5",
             wordSpacing: "6px",
             color: "black",

             fontSize: "23px",
             borderTop: "none",
             textAlign: "justify",
             fontWeight: "bold",
            }}
           >
            يتعهد الطرف الثاني بحماية العقار المستأجَر عن الاستفادة منه والحفاظ
            عليه من التلف والهدم وعدم استخدامه على شكل غير مرغوب فيه.
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fk" : "fkp"}`}
            style={{
             color: `${thirdcolor}`,
             fontSize: "22px",
             borderTop: "none",
            }}
            scope="row"
           >
            9-
           </th>
           <td
            style={{
             lineHeight: "1.5",
             wordSpacing: "6px",
             color: "black",

             fontSize: "23px",
             borderTop: "none",
             textAlign: "justify",
             fontWeight: "bold",
            }}
           >
            من تاريخ توقيع العقد يكون الطرف الثاني هو المسؤول عن دفع تكاليف
            الماء والكهرباء والبلدية وأية خدمة أخرى.
           </td>
          </tr>
         </tbody>
        </table>
       </div>
      </div>
     </div>
     <div className="row content-containers" id="tbls_two">
      <div class="col-12  ">
       <img
        src={primary_logo}
        alt="logo"
        className="img-fluid img-responsive"
        style={{
         width: "100%",
        }}
       />
      </div>
     </div>
     <div className="row mt-2">
      <div className="col-12">
       <table className="table">
        <tbody>
         <tr
          style={{
           fontSize: `${
            lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
           }`,
          }}
         >
          <th
           className={`${lang !== "en" ? "fkp" : "fkp"}`}
           scope="row"
           style={{
            color: `${thirdcolor}`,
            borderTop: "none",
            paddingBottom: "70px",
           }}
          >
           10-
          </th>
          <td
           style={{
            lineHeight: "1.3",
            wordSpacing: "4px",
            color: "black",
            fontSize: "23px",
            borderTop: "none",
            textAlign: "justify",
            fontWeight: "bold",
           }}
          >
           يتعهد الطرف الثاني بدفع الأجرة في الوقت المحدد في العقد. وإذا تأخر
           أكثر من (7) أيام فيتعامل معه حسب الفقرة (1) من المادة (17) من قانون
           تأجير العقار من القانون العراقي المرقم (87) لسنة (1979) وهي تخلية
           العقار مع تحمل تكاليف تبليغ المحكمة مع الأجرة الشهرية.
          </td>
         </tr>
         <tr
          style={{
           fontSize: `${
            lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
           }`,
          }}
         >
          <th
           className={`${lang !== "en" ? "fkp" : "fkp"}`}
           scope="row"
           style={{
            color: `${thirdcolor}`,
            borderTop: "none",
            paddingBottom: "30px",
           }}
          >
           11-
          </th>
          <td
           style={{
            lineHeight: "1.3",
            wordSpacing: "4px",
            color: "black",
            fontSize: "23px",
            borderTop: "none",
            textAlign: "justify",
            fontWeight: "bold",
           }}
          >
           إذا كان العقار المؤجًّر مؤثثا على الطرف الثاني الحفاظ على الأثاث وعند
           التخلية يسلّمها كما كانت؛ خلافاً لذلك يكون الطرف الثاني مسؤولاً عن
           التصليح أو تبديله على مسؤوليته.
          </td>
         </tr>
         <tr
          style={{
           fontSize: `${
            lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
           }`,
          }}
         >
          <th
           className={`${lang !== "en" ? "fkp" : "fkp"}`}
           scope="row"
           style={{
            color: `${thirdcolor}`,
            borderTop: "none",
            paddingBottom: "30px",
           }}
          >
           12-
          </th>
          <td
           style={{
            lineHeight: "1.3",
            wordSpacing: "4px",
            color: "black",
            borderTop: "none",
            textAlign: "justify",
            fontSize: "23px",
            fontWeight: "bold",
           }}
          >
           بعد انتهاء مدة العقد في حال لم يلتزم الطرف الثاني بتخلية العقار أو
           تجديد العقد تكون أجرة العقار &nbsp;(
           <NumberFormat
            displayType="text"
            thousandSeparator={true}
            style={{}}
            value={rent_invoice_obj.feelate}
            className="text-center"
            prefix={`${rent_invoice_obj.currency === "dolar" ? "$" : "ID"}`}
           />
           &nbsp;
           {numWords3}
           {lang === "en" && rent_invoice_obj.currency === "dolar"
            ? "($)"
            : lang === "krd" && rent_invoice_obj.currency === "dolar"
            ? "(دۆلار)"
            : lang === "arb" && rent_invoice_obj.currency === "dolar"
            ? "(دولار)"
            : lang === "en" && rent_invoice_obj.currency !== "dolar"
            ? "(ID)"
            : lang === "krd" && rent_invoice_obj.currency !== "dolar"
            ? "(دینار)"
            : lang === "arb" && rent_invoice_obj.currency !== "dolar"
            ? "(دینار)"
            : ""}
           )&nbsp; إزاء كل يوم إلى أن يتم حسم القضية.
          </td>
         </tr>
         <tr
          style={{
           fontSize: `${
            lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
           }`,
          }}
         >
          <th
           className={`${lang !== "en" ? "fkp" : "fkp"}`}
           scope="row"
           style={{ color: `${thirdcolor}`, borderTop: "none" }}
          >
           13-
          </th>
          <td
           style={{
            lineHeight: "1.3",
            wordSpacing: "4px",
            color: "black",
            fontSize: "23px",
            borderTop: "none",
            textAlign: "justify",
            fontWeight: "bold",
           }}
          >
           إذا تم نقل الملكية للعقار إلى طرف آخر يجب على الصاحب الجديد الإلتزام
           بمضمون هذا العقد.
          </td>
         </tr>
         <tr
          style={{
           fontSize: `${
            lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
           }`,
          }}
         >
          <th
           className={`${lang !== "en" ? "fkp" : "fkp"}`}
           scope="row"
           style={{ color: `${thirdcolor}`, borderTop: "none" }}
          >
           14-
          </th>
          <td
           style={{
            lineHeight: "1.3",
            wordSpacing: "4px",
            color: "black",
            borderTop: "none",
            textAlign: "justify",
            fontSize: "23px",
            fontWeight: "bold",
           }}
          >
           على الطرفين دفع نصف مبلغ الأجرة سنوياً إلى {name_arb}
           بدل تظيم هذا العقد.
          </td>
         </tr>

         <tr
          style={{
           fontSize: `${
            lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
           }`,
          }}
         >
          <th
           className={`${lang !== "en" ? "fkp" : "fkp"}`}
           scope="row"
           style={{
            color: `${thirdcolor}`,
            borderTop: "none",
            paddingBottom: "30px",
           }}
          >
           15-
          </th>
          <td
           style={{
            lineHeight: "1.3",
            wordSpacing: "4px",
            color: "black",
            borderTop: "none",
            textAlign: "justify",
            fontSize: "23px",
            fontWeight: "bold",
           }}
          >
           عند تخلية العقار يجب على الطرف الثاني تسليم العقار كما استلمه دون
           نقصان خلافا لذلك يتحمل المسؤولية لسد النواقص بأسرع وقت ممكن.
          </td>
         </tr>
         <tr
          style={{
           fontSize: `${
            lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
           }`,
          }}
         >
          <th
           className={`${lang !== "en" ? "fkp" : "fkp"}`}
           scope="row"
           style={{
            color: `${thirdcolor}`,
            borderTop: "none",
            paddingBottom: "30px",
           }}
          >
           16-
          </th>
          <td
           style={{
            lineHeight: "1.3",
            wordSpacing: "4px",
            color: "black",
            borderTop: "none",
            textAlign: "justify",
            fontSize: "23px",
            fontWeight: "bold",
           }}
          >
           لا يحق للطرف الثاني بأي وجه من الوجوه أم يخلق مشاكل مع جيران خلافاً
           لذلك يتحمل المسؤولية ويتم فسخ العقد.
          </td>
         </tr>
         <tr
          style={{
           fontSize: `${
            lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
           }`,
          }}
         >
          <th
           className={`${lang !== "en" ? "fkp" : "fkp"}`}
           scope="row"
           style={{
            color: `${thirdcolor}`,
            borderTop: "none",
            paddingBottom: "30px",
           }}
          >
           17-
          </th>
          <td
           style={{
            lineHeight: "1.3",
            wordSpacing: "4px",
            color: "black",
            borderTop: "none",
            textAlign: "justify",
            fontSize: "23px",
            fontWeight: "bold",
           }}
          >
           عند عدم حسم المشاكل بالحوار فيما بين الطرفين لا تتحمل &nbsp;
           {name_arb} المسؤولية بل على الطرفين أن يحسم القضايا من خلال إجراءات
           قانونية واللجوء إلى محكمة خاصة.
          </td>
         </tr>
         <tr
          style={{
           fontSize: `${
            lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
           }`,
          }}
         >
          <th
           className={`${lang !== "en" ? "fkp" : "fkp"}`}
           scope="row"
           style={{ color: `${thirdcolor}`, borderTop: "none" }}
          >
           18-
          </th>
          <td
           style={{
            lineHeight: "1.3",
            wordSpacing: "4px",
            color: "black",
            borderTop: "none",
            textAlign: "justify",
            fontSize: "23px",
            fontWeight: "bold",
           }}
          >
           {name_arb} غير مسؤول عن أي مشاكل أن يحدث بين مالك العقار والمستأجر.
          </td>
         </tr>
        </tbody>
       </table>
      </div>
     </div>
     <div className="form-inline">
      <p
       className="d-flex justify-content-start"
       style={{
        fontSize: "18px",
        color: "black",
        textAlign: "justify",
        fontWeight: "bold",
       }}
      >
       {change_Lang("note")}&nbsp;:{rent_invoice_obj.note}
      </p>
     </div>
     <br /> <br /> <br /> <br />
     <br />
     <div className="row">
      <div className="form-group d-flex justify-content-center col-3">
       <label
        style={{
         fontSize: "22px",
         color: "#000",
         fontWeight: "bold",
        }}
        className="form-label"
       >
        الجانب الأول (مالك العقار)
       </label>
      </div>
      <div className="col-3">
       <div className="form-group d-flex justify-content-center">
        <label
         style={{
          fontSize: "22px",
          color: "#000",
          fontWeight: "bold",
         }}
         className="form-label"
        >
         {change_Lang("Witness")}
        </label>
       </div>
      </div>
      <div className="col-3">
       <div className="form-group d-flex justify-content-center">
        <label
         style={{
          fontSize: "22px",
          color: "#000",
          fontWeight: "bold",
         }}
         className="form-label"
        >
         {change_Lang("Witness")}
        </label>
       </div>
      </div>
      <div className="col-3 d-flex justify-content-center">
       <div className="form-group ">
        <label
         style={{
          fontSize: "22px",
          color: "#000",
          fontWeight: "bold",
         }}
         className="form-label"
        >
         الجانب الثاني (المستأجر)
        </label>
       </div>
      </div>
     </div>
     <div className="row">
      <div className="col-3 form-group d-flex justify-content-center">
       <label
        style={{
         fontSize: "22px",
         color: "#000",
         fontWeight: "bold",
        }}
        className="form-label"
       >
        {rent_invoice_obj.firstname}
       </label>
      </div>
      <div className="col-3">
       <div className="form-group d-flex justify-content-center">
        <label
         style={{
          fontSize: "22px",
          color: "#000",
          fontWeight: "bold",
         }}
         className="form-label"
        >
         {rent_invoice_obj.witness1}
        </label>
       </div>
      </div>
      <div className="col-3">
       <div className="form-group d-flex justify-content-center">
        <label
         style={{
          fontSize: "22px",
          color: "#000",
          fontWeight: "bold",
         }}
         className="form-label"
        >
         {rent_invoice_obj.witness2}
        </label>
       </div>
      </div>
      <div className="col-3 d-flex justify-content-center">
       <div className="form-group ">
        <label
         style={{
          fontSize: "22px",
          color: "#000",
          fontWeight: "bold",
         }}
         className="form-label"
        >
         {rent_invoice_obj.tenantId && rent_invoice_obj.tenantId.secondname}
        </label>
       </div>
      </div>
     </div>
    </div>
    {/* footer */}
    <div
     className="row"
     style={{
      position: "fixed",
      bottom: 47,
      width: "100%",
     }}
    >
     <div className="col-8 d-flex justify-content-end">
      <label
       style={{
        fontSize: 22,
        color: "#000",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
       }}
       className="fk"
      >
       {rent_invoice_obj.branchId ? rent_invoice_obj.branchId.adress : ""}
       &nbsp;&nbsp;
       <FaMapMarkerAlt
        style={{
         color: "#fff",
         background: " #000",
         padding: 5,
         fontSize: 25,
        }}
       />
      </label>
     </div>
     <div className="col-4 d-flex justify-content-end">
      <h4
       style={{
        fontSize: 21,
        color: "#black",
        letterSpacing: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        direction: "ltr",
        lineHeight: 1.5,
       }}
      >
       <FaPhoneAlt
        style={{
         color: "#fff",
         background: " #000",
         padding: 5,
         fontSize: 25,
         marginRight: 20,
        }}
       />
       {rent_invoice_obj.branchId
        ? rent_invoice_obj.branchId.adressNumber1
        : ""}{" "}
       <br />{" "}
       {rent_invoice_obj.branchId
        ? rent_invoice_obj.branchId.adressNumber2
        : ""}
      </h4>
     </div>
    </div>
    <div
     style={{
      position: "fixed",
      bottom: 0,
      width: "100%",
      zIndex: -1,
     }}
    >
     <img src={footer_logo} alt="logo" width="100%" />
    </div>
   </>
  );
 }
}

const mapStateToProps = (state) => {
 return {
  lang: state.HelperReducer.lang,
  rent_invoice_obj: state.Invoice_Reducer.rent_invoice_obj,
  index_rentcontrct: state.Invoice_Reducer.index_rentcontrct,
  user: state.AuthReducer.user,
  primarycolor: state.HelperReducer.primarycolor,
  secondarycolor: state.HelperReducer.secondarycolor,
  thirdcolor: state.HelperReducer.thirdcolor,
  primary_logo: state.HelperReducer.primary_logo,
  footer_logo: state.HelperReducer.footer_logo,
  name_arb: state.HelperReducer.name_arb,
 };
};

const mapDispatchToProps = (dispatch) => {
 return {
  change_Lang: (key) => dispatch(change_Lang(key)),
 };
};

export default connect(mapStateToProps, mapDispatchToProps)(RentPrintArabic);
